// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3UNnC","LoaderBlue":"Spinner_LoaderBlue__3c_SJ","LoaderRed":"Spinner_LoaderRed__2PX3V","lds-dual-ring":"Spinner_lds-dual-ring__2PkiO"};